import { useCallback } from "react";
import { useQueryParam, StringParam } from "routing/QueryParams";
const useLayoutVariant = () => {
  const [layoutVariant, setActiveLayout] = useQueryParam("layout_variant", StringParam);
  const activeLayoutVariant = layoutVariant != null ? layoutVariant : "";
  const selectLayoutVariant = useCallback(
    (layout) => {
      setActiveLayout(layout === activeLayoutVariant ? void 0 : layout);
    },
    [activeLayoutVariant, setActiveLayout]
  );
  return {
    activeLayoutVariant,
    selectLayoutVariant
  };
};
export default useLayoutVariant;
